
export const MESSAGE = Object.freeze({
  da: 'da',
  de: 'de',
  en: 'Check out this boat on Tubber!',
  es: 'es',
  fi: 'fi',
  fr: 'fr',
  gr: 'gr',
  hr: 'hr',
  it: 'it',
  nl: 'nl',
  pl: 'pl',
  pt: 'pt',
  sv: 'sv',
  us: 'us'
})

export const DefaultButton = {
  title: '',
  className: '',
  iconName: 'faExclamationTriangle',
  type: 'default'
}

export const SmsButton = {
  title: 'Sms',
  className: 'sms-button',
  iconName: 'faSms',
  type: 'sms'
}

export const EmailButton = {
  title: 'Email',
  className: 'email-button',
  iconName: 'faEnvelope',
  type: 'email'
}

export const TwitterButton = {
  title: 'Twitter',
  className: 'twitter-button',
  iconName: 'faTwitter',
  type: 'twitter'
}

export const WhatsAppButton = {
  title: 'WhatsApp',
  className: 'whatsapp-button',
  iconName: 'faPhone',
  type: 'whatsapp'
}

export const FacebookButton = {
  title: 'Facebook',
  className: 'facebook-button',
  iconName: 'faFacebookF',
  type: 'facebook'
}

export const MessengerButton = {
  title: 'Messenger',
  className: 'messenger-button',
  iconName: 'faFacebookMessenger',
  type: 'messenger'
}

export const CopyLinkButton = {
  title: 'Copy URL',
  className: 'copy-link-button',
  iconName: 'faLink',
  type: 'copylink'
}

export class SocialButtonService {
  linkUrl = ''
  messageText = ''

  setReferralLink (linkUrl, shortLocale) {
    this.linkUrl = linkUrl
    this.messageText = MESSAGE[shortLocale]
  }

  getConfig (service) {
    switch (service) {
      case 'whatsapp': {
        return WhatsAppButton
      }
      case 'messenger': {
        return MessengerButton
      }
      case 'facebook': {
        return FacebookButton
      }
      case 'copylink': {
        return CopyLinkButton
      }
      case 'twitter': {
        return TwitterButton
      }
      case 'email': {
        return EmailButton
      }
      case 'sms': {
        return SmsButton
      }
      default: {
        return DefaultButton
      }
    }
  }

  triggerCallback (service) {
    switch (service) {
      case 'whatsapp':
        window.open(encodeURI('whatsapp://send?text=' + this.linkUrl))
        break
      case 'facebook':
        window.FB.init({
          appId: '781436315306170',
          cookie: true,
          xfbml: true,
          version: 'v3.3'
        })
        window.FB.ui({
          method: 'share',
          quote: this.messageText,
          href: this.linkUrl
        })
        break
      case 'messenger':
        window.FB.init({
          appId: '781436315306170',
          cookie: true,
          xfbml: true,
          version: 'v3.3'
        })
        window.FB.ui({
          method: 'send',
          link: this.linkUrl
        })
        break
      case 'copylink':
        window.document.querySelector('input#linkInputField').select()
        window.document.execCommand('copy')
        break
      case 'twitter':
        window.open(`https://twitter.com/intent/tweet?url=${this.linkUrl}&text=${this.messageText}`)
        break
      case 'email':
        window.open(`mailto:?&subject=${this.messageText}&cc=&bcc=&body=${this.messageText}%0A${this.linkUrl}`)
        break
      case 'sms':
        window.open(`sms:?&body=${this.messageText}%0A${this.linkUrl}`)
        break
      default:
    }
  }
}
